import React from "react";
import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons/lib";
import { useWatchListContext } from "@/modules/Watchlist/hooks";
import { useWatchListUpdate } from "@/features/applications/hook";

type Props = {
  fullTicker: string;
};

export default ({ fullTicker }: Props) => {
  const { userWatchlist, updateWatchlist } = useWatchListUpdate();
  const { activeKey } = useWatchListContext();

  return (
    <Popconfirm
      key={"delete"}
      placement="left"
      title={`Are you sure to delete ${fullTicker}? This action cannot de undone.`}
      onConfirm={removeFromWatchlist}
      okText="Yes"
      okType={"danger"}
      cancelText="No"
    >
      <Button
        danger
        icon={<DeleteOutlined />}
        shape={"round"}
        size={"small"}
      />
    </Popconfirm>
  );

  function removeFromWatchlist() {
    updateWatchlist({
      ...userWatchlist,
      [activeKey]: userWatchlist[activeKey].filter(e => `${e.exchange}:${e.ticker}` !== fullTicker)
    });
  }
};
